import store from '$redux/store';
import {ApiRoute} from '$constants/api';
import axiosInstance from '$api/index';

interface CreateInsuranceClaimPayload {
  insurance_claim: {
    patient_id: number;
  };
}

interface CreateInsuranceClaimResponse {
  success: boolean;
  data: {
    insurance_claim: {
      id: number;
      membership_no: string | null;
      pre_authorisation_code: number | null;
      status: string;
      insurer_name: string | null;
      patient_name: string;
      amount: number;
      last_updated: string;
    };
  };
  message: string;
}

export const createInsuranceClaim = async (
  payload: CreateInsuranceClaimPayload
): Promise<CreateInsuranceClaimResponse> => {
  const token = store.getState().auth.token;

  const response = await axiosInstance.post(
    `${ApiRoute.InsuranceClaims}/create_blank_insurance_claim`,
    payload,
    {
      headers: {
        Authorization: token,
      },
    }
  );
  return response.data;
};
